import { Injectable } from "@angular/core";
import { MapperInterface } from "../mapper-inteface";
import { DipendenteDTO } from "@app/shared/dto/dipendenteDTO";
import { DipendenteVO } from "@app/shared/vo/dipendenteVO";

@Injectable({
  providedIn: "root"
})
export class MapperDipendente
  implements MapperInterface<DipendenteDTO, DipendenteVO> {
  convertVoToDto(t: DipendenteVO): DipendenteDTO {
    const dipendenteDTO = new DipendenteDTO();
    dipendenteDTO.nome = t.nome;
    dipendenteDTO.cognome = t.cognome;
    dipendenteDTO.descrizioneCmu = t.descrizioneCmu;
    dipendenteDTO.cf = t.cf;
    dipendenteDTO.matricola = t.matricola;
    dipendenteDTO.cmu = t.cmu;
    dipendenteDTO.codiceEnte = t.codiceEnte;

    return dipendenteDTO || new DipendenteDTO();
  }
  convertDtoToVo(t: DipendenteDTO): DipendenteVO {
    const dipendenteVO = new DipendenteVO();
    dipendenteVO.nome = t.nome;
    dipendenteVO.cognome = t.cognome;
    dipendenteVO.descrizioneCmu = t.descrizioneCmu;
    dipendenteVO.cf = t.cf;
    dipendenteVO.matricola = t.matricola;
    dipendenteVO.cmu = t.cmu;
    dipendenteVO.codiceEnte = t.codiceEnte;

    return dipendenteVO || new DipendenteVO();
  }
  convertListVoToDto(e: DipendenteVO[]): DipendenteDTO[] {
    const dipendenteDTOList = new Array<DipendenteDTO>();
    e.forEach((dipendenteVO) => {
      dipendenteDTOList.push(this.convertVoToDto(dipendenteVO));
    });
    return dipendenteDTOList || new Array<DipendenteDTO>();
  }
  convertListDtoToVo(t: DipendenteDTO[]): DipendenteVO[] {
    const dipendenteVOList = new Array<DipendenteVO>();
    t.forEach((dipendenteDTO) => {
      dipendenteVOList.push(this.convertDtoToVo(dipendenteDTO));
    });
    return dipendenteVOList || new Array<DipendenteVO>();
  }
}
